/**
 * @deprecated Usa FilePreviewEmailComponent da @sia/file-system
 * Questo componente e mantenuto per retrocompatibilita.
 */
export { FilePreviewEmailComponent as AiFilePreviewEmailComponent } from '@sia/file-system';
